<!-- 单项选择题 -->
<template>
  <div class="topic_choice">
    <div class="flex topic_select">
      <!-- <div class="topic_type">{{ questionTypeName }}</div> -->
      <div class="topic_content scroll_x mar_left_10 flex-1">
        <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
        <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
          <div class="mr-10">音频：</div>
          <audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
        </div>
        <div class="mt-10">
          <div class="flex Flexalign" v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
            <div>{{ item.label }} .</div>
            <div v-html="$Tools.handlerImg(item.content)" v-mathml></div>
          </div>
        </div>
        <div v-if="!((testExamTime.remainingTime < 0) || isShowScoring ||
          topicInfo.showAnalysis)">
          <el-select v-model="selectedValue" placeholder="请选择你的答案顺序" :disabled="testExamTime.remainingTime < 0 ||
            isShowScoring ||
            topicInfo.showAnalysis
            " style="min-width: 240px; max-width: 360px; margin-top: 30px" clearable multiple @change="changeAnswer">
            <template #label="{ label, serial }">
              <span>{{ label }}: </span>
              <span style="font-weight: bold">{{ serial }}</span>
            </template>
            <el-option v-for="(item, index) in topicInfo.questionContext?.options" :key="index" :label="item.label"
              :value="item.label" />
          </el-select>
        </div>
      </div>
    </div>
    <!-- <div v-if="!testType">
      <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
        <div class="answer_top p-20">
          <div>答题结果</div>
          <div class="flex FlexBetween mt-20">
            <div>
              参考答案：<span class="correct_value_answer">{{
                topicInfo.questionContext?.answer
              }}</span>
            </div>
            <div class="mar_left_20 user_answer" v-if="!hideUserAnswer">
              你的答案：<span class="error_value_answer" :class="topicInfo.questionContext?.answer == topicInfo.doAnswer
                ? 'correct_value_answer'
                : ''
                ">{{ topicInfo.doAnswer }}</span>
              <div class="bg_line"></div>
            </div>
            <div class="mar_left_20 flex">
              <div class="full_score">
                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                  v-if="topicInfo.isCorrect == 2"></el-image>
                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                  v-if="topicInfo.isCorrect == 1"></el-image>
              </div>
              <div class="get_score ml-10" v-if="!hideUserAnswer">
                得分：{{ topicInfo.score || 0 }}
              </div>
            </div>
          </div>
        </div>
        <div class="answer_top p-20 mt-20">
          <div class="question_analyze mar_top_10">【试题分析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)"></div>
          <div class="question_analyze mar_top_10">【解析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)"></div>
        </div>
      </div>
    </div> -->
    <div>
      <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
        <div class="answer_top p-20" v-if="getIsShow(1) || showAnswer">
          <div>答题结果</div>
          <div class="flex FlexBetween mt-20">
            <div>
              参考答案：<span class="correct_value_answer">{{
                topicInfo.questionContext?.answer
              }}</span>
            </div>
            <div class="mar_left_20 user_answer" v-if="!hideUserAnswer">
              你的答案：<span class="error_value_answer" :class="topicInfo.questionContext?.answer == topicInfo.doAnswer
                ? 'correct_value_answer'
                : ''
                ">{{ topicInfo.doAnswer }}</span>
              <div class="bg_line"></div>
            </div>
            <div class="mar_left_20 flex">
              <div class="full_score">
                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                  v-if="topicInfo.isCorrect == 2"></el-image>
                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                  v-if="topicInfo.isCorrect == 1"></el-image>
              </div>
              <div class="get_score ml-10" v-if="!hideUserAnswer">
                得分：{{ topicInfo.questionScore }}
              </div>
            </div>
          </div>
          <!-- <div class="btn_ask">提问</div> -->
        </div>
        <div class="answer_top p-20 mt-20" v-if="getIsShow(2) || getIsShow(3) || showAnswer">
          <div class="question_analyze mar_top_10" v-if="getIsShow(2) || showAnswer">【试题分析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-if="getIsShow(2) || showAnswer" v-mathml></div>
          <div class="question_analyze mar_top_10" v-if="getIsShow(3) || showAnswer">【解析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-if="getIsShow(3) || showAnswer" v-mathml></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5Sort",
  props: {
    questionInfo: {},
    isShowScoring: {
      default: false,
    },
    questionTypeName: {
      default: "排序题",
    },
    testType: {},
    //  用于错题展示隐藏用户答案信息等
    hideUserAnswer: {
      default: false,
    },
    isChallenge: {},
    showAnswer:{}, // 用于测评报告弹题展示解析等
  },
  computed: {
    ...mapState({
      testExamTime: (state) => state.exam.testExamTime,
      testExamInfo: (state) => state.exam.testExamInfo,
    }),
  },

  data() {
    return {
      topicInfo: {},
      selectedValue: [],
    };
  },
  watch: {
    questionInfo: {
      handler(val) {
        if (val) {
          this.topicInfo = this.questionInfo;
          // 判断是否回答过
          // if (this.topicInfo.courseExamRecordId) {
          this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
          // }
          this.selectedValue = [];
          if (!this.$Tools.empty(this.topicInfo.questionContext.doAnswer)) {
            this.selectedValue =
              this.topicInfo.questionContext.doAnswer.split("");
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.setRecordTimeInterval();
  },
  beforeUnmount() {
    if (this.recordTimeInterval) {
      clearInterval(this.recordTimeInterval);
      this.recordTimeInterval = null;
    }
  },

  methods: {
    setRecordTimeInterval() {
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        this.recordTimeInterval = setInterval(() => {
          if (this.topicInfo.answerSection == null) {
            this.topicInfo.answerSection = 1;
          } else {
            this.topicInfo.answerSection++;
          }
          // 按每题作答时间提交
          if (this.testExamInfo.otherRule.timeType == 2) {
            this.$emit("answerQuestion", this.topicInfo);
            // 当作答时间超过设定时间，该题设置为已完成并且不给作答
            if (
              this.topicInfo.answerSection >=
              this.testExamInfo.otherRule.perQuestionTime
            ) {
              this.topicInfo.questionContext.isFinish = true;
              this.$emit("answerQuestion", this.topicInfo);
              setTimeout(() => {
                this.$emit("showAnalysis", true);
              }, 1000)
              if (this.recordTimeInterval) {
                clearInterval(this.recordTimeInterval);
                this.recordTimeInterval = null;
              }
            }
          }
          // 判断当提交后定时器关闭 
          else if (this.isShowScoring || this.topicInfo.showAnalysis) {
            if (this.recordTimeInterval) {
              clearInterval(this.recordTimeInterval);
              this.recordTimeInterval = null;
            }
          }
        }, 1000);
      }
    },
    getIsShow(showId) {
      let flag = false;
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
          if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
            flag = true;
          }
        }
      }
      return flag
    },
    getAudioUrl(info) {
      let ruleInfo = this.$Tools.jsonDecode(info);
      if (!this.$Tools.empty(ruleInfo)) {
        return ruleInfo.listeningRule?.audioUrl;
      }
    },
    changeAnswer(value) {
      this.topicInfo.doAnswer = value.map(String).join("");
      if (this.topicInfo.doAnswer == this.topicInfo.questionContext?.answer) {
        this.topicInfo.isCorrect = 1;
      } else {
        this.topicInfo.isCorrect = 2;
      }
      this.topicInfo.questionScore =
        this.topicInfo.isCorrect == 1
          ? this.topicInfo.questionContext.score
          : 0; // 得分
      this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer; // 保存答案
      this.topicInfo.questionContext.isFinish = !this.$Tools.empty(
        this.topicInfo.questionContext.doAnswer
      ); // 是否已完成
      //   this.$emit("answerQuestion", this.topicInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.topic_select {
  .topic_type {
    // margin-top: 1rem;
    min-width: 45px;
    padding: 0 8px;
    height: 21px;
    background: rgba(0, 199, 88, 0.2);
    border-radius: 4px;
    border: 1px solid #00c758;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #00c758;
  }

  .topic_content {
    // overflow-x: auto;

    .topic_title {
      font-size: 16px;
      color: #242324;
      font-weight: 600;
    }
  }
}

.bottom_box {
  position: absolute;
  left: calc(50% - 60px);
  bottom: 40px;
  text-align: center;

  .btn_view {
    width: 120px;
    height: 42px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 21px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    font-size: 18px;
  }

  .view_analysis {
    color: #13d6aa;
  }
}

.topic_answer {
  width: 100%;
  // height: 222px;
  // background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  // padding: 20px;
  color: #666666;
  box-sizing: border-box;

  .answer_top {
    background: #F8F9FA;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;

    .user_answer {
      position: relative;

      .bg_line {
        width: 73px;
        height: 8px;
        background: rgba(19, 214, 170, 0.2);
        position: absolute;
        bottom: 6px;
        left: 0;
      }
    }

    .question_error_icon {
      width: 26px;
      height: 26px;
    }


    .error_value_answer {
      color: RGBA(255, 49, 49, 1);
    }

    .correct_value_answer {
      color: RGBA(0, 199, 88, 1);
    }

    .btn_ask {
      width: 64px;
      height: 28px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 14px;
      line-height: 28px;
      text-align: center;
      color: #fff;
    }

    .get_score {
      color: #fd673b;
    }
  }

  .question_analyze {
    color: #333333;
    font-weight: 600;
  }
}
</style>
